<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
          <li class="breadcrumb-item" disabled><a routerLink="/corporate/subscription-license-category-list">License Category</a></li>
          <li class="breadcrumb-item active" aria-current="page">Add License Category</li>
      </ol>
  </nav>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-8">
      <form class="form-horizontal" [formGroup]="addCategoryForm">
        <div class="card">
          <div class="card-body">
            <div class="form-group" *ngIf="customer_id===0">
              <label>Company Name <span class="required">*</span></label>
              <select formControlName="selectedCompany" class="form-control formstyle"
                [ngClass]="{ 'is-invalid': submitted && f.selectedCompany.errors }">
                <option value="">Select Company Name</option>
                <ng-container *ngFor="let Obj of getCompanyobj">
                  <option *ngIf="Obj.dbstatus == true" value={{Obj.customer_id}}>
                    {{Obj.customer_company_name}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="submitted && f.selectedCompany.errors" class="invalid-feedback">
                <div *ngIf="f.selectedCompany.errors.required">Company Name is required</div>
              </div>
            </div>
            <input *ngIf="customer_id!=0" type="hidden" formControlName="selectedCompany">
            <div class="form-group">
              <label>Category Name <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="category_name"
                [ngClass]="{ 'is-invalid': submitted && f.category_name.errors }" maxlength="255">
              <div *ngIf="submitted && f.category_name.errors" class="invalid-feedback">
                <div *ngIf="f.category_name.errors.required">Category name is required</div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button class="btn btn-round btn-margo-action" type="button" (click)="addNewCategory()">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
